module.exports = __webpack_public_path__ + "img/delivery.491a4f9d.png";